// import { baseUrl } from "./../index"
// import { FileTransfer, FileTransferObject } from "@ionic-native/file-transfer";

import {
  FileTransfer,
  FileTransferObject,
} from "@awesome-cordova-plugins/file-transfer"
import axios from "axios"
import { config } from "process"
import { useSelector } from "react-redux"
import { Department, Employee } from "../global"
import storageHelper from "./storageHelper"
import { Document } from "../global"
const ISO_8601 = /(\d{4}-\d{2}-\d{2})T(\d{2}:\d{2}:\d{2})Z/

export interface AuthResponse {
  access: string
  refresh: string
  must_change_password?: boolean
}
export interface AuthData {
  username: string
  password: string
}

export interface PasswordResetRequestData {
  email: string
}

export interface PasswordResetConfirmData extends PasswordResetRequestData {
  code: string
  new_password: string
  confirmed_password: string
}

export interface ProfileResponse {
  uuid: string
  id: number
  username: string
  email: string
  groups: string[]
  is_staff: boolean
  admin_url?: string
  isStudent: boolean
  isTutor: boolean
  isEditor: boolean
  employee: Employee
}
export interface DocumentsResponse {
  results: Document[]
  first?: number
  next_link: string
  last_link: string
}

export interface DocumentGroup {
  id: number
  name: string
  ordering: number
}

export interface EmployeesResponse {
  results: Employee[]
  first?: number
  next_link: string
  last_link: string
}

export interface EmployeeResponse {
  results: Employee
}

export interface DepartmentsResponse {
  results: Department[]
  first?: number
  next_link: string
  last_link: string
}

export interface AccessTokenResponse {
  access: string
}

export interface EvaluationQuestion {
  id: number
  uuid: string
  template: number
  text: string
  question_type: "rating" | "boolean" | "text"
  ordering: number
  is_required: boolean
  help_text: string
}

export interface EvaluationTemplate {
  id: number
  uuid: string
  title: string
  description: string
  version: number
  is_active: boolean
  questions: EvaluationQuestion[]
}

export interface EvaluationAnswer {
  id?: number
  question: number
  question_text?: string
  question_type?: "rating" | "boolean" | "text"
  rating_value?: number | null
  boolean_value?: boolean | null
  text_value?: string
}

export interface EvaluationUser {
  id: number
  username: string
  email: string
  first_name: string
  last_name: string
}

export interface Evaluation {
  id: number
  uuid: string
  template: number
  template_detail?: EvaluationTemplate
  trainee: number
  trainee_detail?: EvaluationUser
  teacher?: number
  teacher_detail?: EvaluationUser
  department?: number | null
  period_start?: string | null
  period_end?: string | null
  status: "draft" | "submitted" | "locked"
  notes: string
  answers: EvaluationAnswer[]
  is_editable: boolean
  created_at: string
  updated_at: string
  submitted_at?: string | null
  locked_at?: string | null
}

export interface EvaluationsResponse {
  results: Evaluation[]
  next_link: string
  last_link: string
}

export interface EvaluationTemplatesResponse {
  results: EvaluationTemplate[]
}
export interface RotationEvaluationQuestion {
  id: number
  text: string
  question_type: "rating" | "text"
  ordering: number
  is_required: boolean
  help_text: string
}

export interface RotationEvaluationQuestionnaire {
  id: number
  uuid: string
  name: string
  description: string
  scale_min: number
  scale_max: number
  rating_labels: string[]
  visible_days_before_end: number
  visible_days_after_end: number
  questions: RotationEvaluationQuestion[]
}

export interface RotationEvaluationAssignment {
  id: number
  rotation: number
  rotation_name: string
  period_start?: string | null
  period_end?: string | null
  questionnaire: RotationEvaluationQuestionnaire
  is_active: boolean
}

export interface RotationEvaluationAssignmentsResponse {
  results: RotationEvaluationAssignment[]
}
export interface FeedbackResponse {
  id: number
  uuid: string
  section: string
  message: string
  attachment?: string
  status: "new" | "resolved"
  created_at: string
}
export interface FeedbackSection {
  id: number
  name: string
  slug: string
  ordering: number
}
export interface OccurrenceResponse {
  id: string
  title: string
  start: Date
  end: Date
  existed: boolean
  event_id: number
  color: string
  description: string
  rule: string
  end_recurring_period: Date
  creator: string
  calendar: string
  cancelled: boolean
}

export interface CalDAVAccountResponse {
  server_url: string
  username: string
  default_collection: string
  default_calendar_url: string
  visible_calendars: { id: number; slug: string; name: string; color: string; permission: string; url: string }[]
  auth: string
}

const cancelToken = axios.CancelToken
const source = cancelToken.source()

const createPublicAxios = () => {
  const publicAxios = axios.create({ baseURL: axios.defaults.baseURL })
  // Reset password xe pubblico: no ghe mandemo token veci che pol far 401/403.
  delete publicAxios.defaults.headers.common["Authorization"]
  delete publicAxios.defaults.headers.common["authorization"]
  return publicAxios
}

// const cancelProjectRequests = () => {
//   projectGetSource.cancel("Eliminate tutte le pending get projects"); //Elimino le precendenti
//   projectGetSource = CancelToken.source(); //Genero un nuovo token
// };

class API {
  //-------------TOKEN----------------

  async getAccessToken<Promise>(refreshToken: string) {
    const uninterceptedAxios = axios.create({ baseURL: axios.defaults.baseURL })
    const response = await uninterceptedAxios.post<AccessTokenResponse>(
      `/api-token-refresh/`,
      { refresh: refreshToken }
    )
    if (response.status === 200) {
      return response.data
    } else {
      throw new Error("Error in getting new token")
    }
  }
  async changePassword<Promise>(
    oldPassword: string,
    newPassword: string,
    confirmedPassword: string
  ) {
    const response = await axios.put("/users/api/changepassword/", {
      old_password: oldPassword,
      new_password: newPassword,
      confirmed_password: confirmedPassword,
    })
    if (response.status == 200) {
      return
    } else {
      throw new Error("Error in changing password")
    }
  }

  async requestPasswordReset<Promise>(data: PasswordResetRequestData) {
    const publicAxios = createPublicAxios()
    const response = await publicAxios.post("/users/api/password-reset/request/", data)
    if (response.status === 200) {
      return response.data
    }
    throw new Error("Error in requesting password reset")
  }

  async confirmPasswordReset<Promise>(data: PasswordResetConfirmData) {
    const publicAxios = createPublicAxios()
    const response = await publicAxios.post("/users/api/password-reset/confirm/", data)
    if (response.status === 200) {
      return response.data
    }
    throw new Error("Error in confirming password reset")
  }

  async login<Promise>(authData: AuthData) {
    const uninterceptedAxios = axios.create({ baseURL: axios.defaults.baseURL })
    const response = await uninterceptedAxios.post<AuthResponse>(
      "/api-token-auth/",
      {
        ...authData,
      }
    )
    if (response.status === 200 && response.data.access) {
      const accessToken = response.data.access
      const refreshToken = response.data.refresh
      storageHelper.putAccessToken(accessToken)
      storageHelper.putRefreshToken(refreshToken)
      axios.defaults.headers.common["Authorization"] = `JWT ${accessToken}`
      return response
    } else {
      throw new Error("Invalid credentials supplied")
    }
  }

  async getProfile<Promise>() {
    const response = await axios.get<ProfileResponse>(`/users/api/profile/`)
    if (response.status === 200) {
      return response.data
    } else {
      throw new Error("Error in getting profile")
    }
  }

  async ensureProfileEmployee<Promise>() {
    const response = await axios.post<ProfileResponse>(`/users/api/profile/`)
    if (response.status === 201 || response.status === 200) {
      return response.data
    } else {
      throw new Error("Error in creating profile employee")
    }
  }

  async getCalDAVAccount<Promise>() {
    const response = await axios.get<CalDAVAccountResponse>(`/api/schedule/caldav/`)
    if (response.status === 200) {
      return response.data
    } else {
      throw new Error("Error in getting CalDAV account")
    }
  }

  //-------------DOCUMENTS----------------

  async getDocumentGroups() {
    const response = await axios.get<DocumentGroup[]>(`/api/documents/groups/`)
    if (response.status === 200) {
      return response.data
    } else {
      throw new Error("Error in getting document groups")
    }
  }

  async getDocuments<Promise>(nextLink: string, type: string) {
    console.log("nextLink: ", nextLink)
    console.log("type: ", type)
    const response = await axios.get<DocumentsResponse>(
      nextLink === "" || nextLink == null
        ? `/api/documents/search/?group=${encodeURIComponent(type)}`
        : nextLink
    )
    if (response.status === 200) {
      return response.data
    } else {
      throw new Error("Error in getting documents")
    }
  }

  async searchDocuments<Promise>(searchText: string, group?: string) {
    const params = new URLSearchParams({ search: searchText })
    if (group) {
      params.set("group", group)
    }

    const response = await axios.get<Document[]>(
      `/api/documents/search/?${params.toString()}`
    )
    if (response.status === 200) {
      return response.data
    } else {
      throw new Error("Error in searching documents")
    }
  }

  async getDocumentBlobUrl(fileUrl: string) {
    // I PDF no i xe più pubblici su S3: li ciapemo dal backend col JWT e creemo un URL locale.
    const response = await axios.get(fileUrl, { responseType: "blob" })
    return URL.createObjectURL(response.data)
  }

  //-------------EVALUATIONS----------------

  async getEvaluationTemplates() {
    const response = await axios.get<EvaluationTemplatesResponse>(
      `/api/evaluations/templates/`
    )
    if (response.status === 200) {
      return response.data.results
    } else {
      throw new Error("Error in getting evaluation templates")
    }
  }

  async getEvaluationTrainees() {
    const response = await axios.get<EvaluationUser[]>(`/api/evaluations/trainees/`)
    if (response.status === 200) {
      return response.data
    } else {
      throw new Error("Error in getting evaluation trainees")
    }
  }

  async getEvaluations() {
    const response = await axios.get<EvaluationsResponse>(`/api/evaluations/`)
    if (response.status === 200) {
      return response.data.results
    } else {
      throw new Error("Error in getting evaluations")
    }
  }

  async createEvaluation(evaluation: Partial<Evaluation>) {
    const response = await axios.post<Evaluation>(`/api/evaluations/`, evaluation)
    if (response.status === 201) {
      return response.data
    } else {
      throw new Error("Error in creating evaluation")
    }
  }

  async updateEvaluation(evaluationId: number, evaluation: Partial<Evaluation>) {
    const response = await axios.patch<Evaluation>(
      `/api/evaluations/${evaluationId}/`,
      evaluation
    )
    if (response.status === 200) {
      return response.data
    } else {
      throw new Error("Error in updating evaluation")
    }
  }

  async submitEvaluation(evaluationId: number) {
    const response = await axios.post<Evaluation>(
      `/api/evaluations/${evaluationId}/submit/`
    )
    if (response.status === 200) {
      return response.data
    } else {
      throw new Error("Error in submitting evaluation")
    }
  }

  //-------------ROTATION EVALUATIONS----------------

  async getRotationEvaluationAssignments() {
    const response = await axios.get<RotationEvaluationAssignmentsResponse>(
      `/api/valutazione-rotazioni/assignments/`
    )
    if (response.status === 200) {
      return response.data.results
    } else {
      throw new Error("Error in getting rotation evaluation assignments")
    }
  }

  async submitRotationEvaluation(
    assignmentId: number,
    answers: { question: number; rating_value?: number | null; text_value?: string }[]
  ) {
    const response = await axios.post<RotationEvaluationAssignment>(
      `/api/valutazione-rotazioni/assignments/${assignmentId}/submit/`,
      { answers: answers }
    )
    if (response.status === 201) {
      return response.data
    } else {
      throw new Error("Error in submitting rotation evaluation")
    }
  }

  //-------------FEEDBACK----------------

  async getFeedbackSections() {
    const response = await axios.get<FeedbackSection[]>(`/api/feedback/sections/`)
    if (response.status === 200) {
      return response.data
    } else {
      throw new Error("Error in getting feedback sections")
    }
  }

  async submitFeedback(
    section: string,
    message: string,
    attachment?: File | null
  ) {
    const data = new FormData()
    data.append("section", section)
    data.append("message", message)
    if (attachment) {
      data.append("attachment", attachment, attachment.name)
    }

    const response = await axios.post<FeedbackResponse>(`/api/feedback/`, data)
    if (response.status === 201) {
      return response.data
    } else {
      throw new Error("Error in submitting feedback")
    }
  }

  //-------------EMPLOYEES----------------

  async getEmployees<Promise>(nextLink: string) {
    const response = await axios.get<EmployeesResponse>(
      nextLink === "" || nextLink == null
        ? `/api/organization/employees/`
        : nextLink
    )
    console.log(`axios.get<EmployeesResponse>`)
    if (response.data) {
      return response.data
    } else {
      throw new Error("Error in getting employees")
    }
  }

  async getEmployee<Promise>(id: string) {
    const response = await axios.get<Employee>(
      `/api/organization/employees/${id}/`
    )
    if (response.status === 200) {
      return response.data
    } else {
      throw new Error("Error in getting employee")
    }
  }

  async updateEmployee<Promise>(id: string, employee: Partial<Employee>) {
    const response = await axios.patch<Employee>(
      `/api/organization/employees/${id}/`,
      employee
    )
    if (response.status === 200) {
      return response.data
    } else {
      throw new Error("Error in updating employee")
    }
  }

  async searchEmployees<Promise>(searchText: string) {
    console.log("SEARCH EMPLOYEES API: ", searchText)
    console.log(`searchText: ${searchText}`)
    if (searchText.length > 0) {
      console.log(`searchText.length > 0`)
      const params = new URLSearchParams({ search: searchText })
      const response = await axios.get<EmployeesResponse>(
        `/api/organization/employees/search/?${params.toString()}`,
        { cancelToken: source.token }
      )
      if (response.status == 200) {
        return response.data
      } else {
        throw new Error("Error in searching employees")
      }
    }
  }

  //-------------DEPARTMENTS----------------

  async getDepartments<Promise>(nextLink: string, section?: string) {
    console.log("api.getDepartments: nextLink = ", nextLink)
    const sectionQuery = section ? `?section=${encodeURIComponent(section)}` : ""
    const response = await axios.get<EmployeesResponse>(
      nextLink === "" || nextLink == null
        ? `/api/organization/departments/${sectionQuery}`
        : nextLink
    )
    if (response.status == 200) {
      return response.data
    } else {
      throw new Error("Error in getting employees")
    }
  }

  async searchDepartments<Promise>(searchText: string, section?: string) {
    const params = new URLSearchParams({ search: searchText })
    if (section) {
      params.set("section", section)
    }

    const response = await axios.get<DepartmentsResponse>(
      `/api/organization/departments/search/?${params.toString()}`
    )
    if (response.status == 200) {
      return response.data
    } else {
      throw new Error("Error in searching departments")
    }
  }

  async getDepartment<Promise>(id: string) {
    const response = await axios.get<DepartmentsResponse>(
      `/api/organization/departments/${id}/`
    )
    if (response.status === 200) {
      return response.data
    } else {
      throw new Error("Error in getting employee")
    }
  }

  //------------PHOTO---------------
  async getProtectedImageUrl<Promise>(url: string) {
    if (!url || url.startsWith("blob:") || url.startsWith("data:")) {
      return url
    }

    const response = await axios.get(url, { responseType: "blob" })
    return URL.createObjectURL(response.data)
  }

  async uploadImage<Promise>(
    employeeId: string,
    targetPath: string,
    fileName: string
  ) {
    const url = `/api/organization/employees/${employeeId}/picture/`

    if (targetPath.startsWith("blob:") || targetPath.startsWith("data:") || targetPath.startsWith("http")) {
      // PWA/web: niente Cordova FileTransfer, mandemo un multipart normale.
      const response = await fetch(targetPath)
      const blob = await response.blob()
      const data = new FormData()
      data.append("picture", blob, fileName)
      return axios.put(url, data)
    }

    const options = {
      fileKey: "picture",
      fileName: fileName,
      chunkedMode: false,
      mimeType: "image/jpeg",
      params: { picture: fileName },
      httpMethod: "PUT",
      headers: { Authorization: "JWT " + storageHelper.getAccessToken() },
    }
    const fileTransfer: FileTransferObject = FileTransfer.create()
    const uploadUrl = `${axios.defaults.baseURL}/api/organization/employees/${employeeId}/picture/`
    return fileTransfer.upload(targetPath, uploadUrl, options)
  }

  //-------------------SCHEDULE------------------------------
  async getOccurrences<Promise>(
    start: string,
    end: string,
    calendar: string
  ) {
    // console.log("start: ", start)
    // console.log("end: ", end)
    const calendarQuery = calendar ? `&calendar_slug=${calendar}` : ""
    const response = await axios.get<OccurrenceResponse[]>(
      `/api/schedule/caldav/events/?start=${start}&end=${end}${calendarQuery}`
      // {

      //   //@ts-ignore
      //   transformResponse: axios.defaults.transformResponse?.concat(function (
      //     data: any,
      //     headers: any
      //   ) {
      //     data.forEach(function (occ: any, index: number) {
      //       Object.keys(occ).forEach(function (k) {
      //         if (ISO_8601.test(data[index][k])) {
      //           data[index][k] = new Date(Date.parse(data[index][k]))
      //         }
      //       })
      //     })
      //     return data
      //   }),
      // }
    )
    if (response.status === 200) {
      return response
    } else {
      throw new Error("Error in getting occurrences")
    }
  }
}

export default new API()
